import posthog from 'posthog-js';
import { PostHogProvider as PHProvider, usePostHog } from 'posthog-js/react'
import { useAtomValue } from 'jotai'
import { userAtom } from '@/stores/userStore'
import { useEffect } from 'react'
import type { ReactNode } from 'react'

if (import.meta.env.VITE_POSTHOG_API_KEY) {
  posthog.init(import.meta.env.VITE_POSTHOG_API_KEY, {
    api_host: import.meta.env.VITE_POSTHOG_APP_URL,
    defaults: '2026-01-30',
  });
}


function PostHogIdentifier() {
  const posthogClient = usePostHog()
  const user = useAtomValue(userAtom)

  useEffect(() => {
    if (user?.email) {
      posthogClient.identify(user.email, {
        email: user.email,
        first_name: user.first_name,
        last_name: user.last_name,
        company: user.company,
        country: user.country,
      })
    }
  }, [user, posthogClient])

  return null
}

export default function PostHogProvider({ children }: { children: ReactNode }) {
  if (!import.meta.env.VITE_POSTHOG_API_KEY) {
    return <>{children}</>
  }

  return (
    <PHProvider client={posthog}>
      <PostHogIdentifier />
      {children}
    </PHProvider>
  )
}
